import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { chatMessageSent } from '../../store/offer_chats';
import { setPhoneCollapse } from '../../store/phone_collapse/index';
import { isLeadFactory } from '../../utils/agent';
import { ContactsMain, IContactsMainDispatchProps, IContactsMainStoreProps } from './index';
import { getDynamicCalltrackingSiteBlockId } from '../../selectors/getDynamicCalltrackingSiteBlockId';
import { getNewbuildingId } from '../../selectors';
import { getDemandExperiment } from '../../utils/newRequestDemandPositionExperiment';

function mapStateToProps(state: IState): IContactsMainStoreProps {
  return {
    abGroup: state.abGroup,
    agent: state.offerData.agent,
    agentAvailability: state.offerData.agentAvailability,
    kp: state.offerData.kp,
    offer: state.offerData.offer,
    offerChat: state.offerChat,
    user: state.offerData.user,
    siteBlockId: getDynamicCalltrackingSiteBlockId(state),
    newbuildingId: getNewbuildingId(state),
    requestDemandPosition: getDemandExperiment(state.abUseExperiments),
    isAuthenticated: !!(state.offerData.user && state.offerData.user.isAuthenticated),
    isLeadFactory: isLeadFactory(state.offerData.offer),
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IContactsMainDispatchProps {
  return {
    chatMessageSent: () => dispatch(chatMessageSent()),
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ContactsMainContainer = connect<IContactsMainStoreProps, IContactsMainDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsMain);
